import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class CurrentAptService {

  private currentAirportSource = new BehaviorSubject('');
  currentAirport = this.currentAirportSource.asObservable();

  private currentCitySource = new BehaviorSubject('');
  currentCity = this.currentCitySource.asObservable();

  constructor() { }

  setCurrentAirport(currentLocid: string) {

    this.currentAirportSource.next(currentLocid);
  }

  setCurrentCity(currentSearchCity: string) {
    this.currentCitySource.next(currentSearchCity);
  }
}
